import { IIconProps } from '~/types';

const AedFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.25}
      y={0.25}
      width={27.5}
      height={19.5}
      rx={1.75}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
    />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={1.75}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
      />
    </mask>
    <g mask="url(#a)" fillRule="evenodd" clipRule="evenodd">
      <path d="M8 6.667h20V0H8z" fill="#12833B" />
      <path d="M8 20h20v-6.666H8z" fill="#262626" />
      <path d="M0 20h8V0H0z" fill="#FF323E" />
    </g>
  </svg>
);
export default AedFlag;
